import { FISCAL_CODE_REGEX } from "../../../constants/regex";
import * as Yup from 'yup';
import { InputsSchema } from "../../../hooks/buildRegisterForm/validationSchema";

export const accountCreateEditValidationSchema = (getTranslation: (key: string) => string) => {
    return {
    
        email: InputsSchema.EMAIL({
          required: true,
          properties: {
            errorMessageRequired: 'EMAIL_REQUIRED',
            label: 'EMAIL',
          },
        }),
  
     
        firstName: Yup.string().required(getTranslation('FIRST_NAME_REQUIRED')),
        lastName: Yup.string().required(getTranslation('LAST_NAME_REQUIRED')),
        fiscalCode: Yup.string().required(getTranslation('FISCAL_CODE_REQUIRED')).matches(FISCAL_CODE_REGEX, getTranslation('ENTER_VALID_FISCAL_CODE')),
        placeOfBirth: Yup.string().required(getTranslation('PLACE_OF_BIRTH_REQUIRED')),
        dateOfBirth: Yup.date().required(getTranslation('DATE_OF_BIRTH_REQUIRED')).nullable(),
        disabilityCategoryCode: Yup.string().required(getTranslation('DISABILITY_CATEGORY_CODE_REQUIRED')),
        gender: Yup.string().required(getTranslation('GENDER_REQUIRED')),
  
      
      };
}